import React from 'react';
export function BonusItems() {
  return <section className="py-[30px] px-0" data-id="element-61">
      <div className="container max-w-[700px] mx-auto px-[15px] text-center" data-id="element-62">
        <h2 className="text-[24px] text-center mb-[20px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-63">
          🎁 BONUS ESPECIALES DE HOY
        </h2>
        <div className="grid grid-cols-[repeat(auto-fill,minmax(140px,1fr))] gap-[15px] mt-[25px] mx-auto max-w-[700px]" data-id="element-64">
          <div className="bg-white border border-[#eee] rounded-[8px] p-[10px] text-center transition-all duration-400 shadow-[0_4px_10px_rgba(0,0,0,0.05)] hover:transform hover:-translate-y-[5px] hover:shadow-[0_10px_20px_rgba(0,0,0,0.08)]" data-id="element-65">
            <img src="https://app.heylloyd.io/public/files/openrouter-generated-image-1770583484324.png" alt="Checklist" className="w-full rounded-[4px] mb-[10px]" data-id="element-66" />
            <h3 className="text-[14px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-67">
              📋 Checklist de 5 minutos
            </h3>
            <div className="font-bold" data-id="element-68">
              <span className="text-[#EF4444] line-through" data-id="element-69">$9.99</span>
              <span className="text-[#10B981] block" data-id="element-70">HOY GRATIS</span>
            </div>
          </div>

          <div className="bg-white border border-[#eee] rounded-[8px] p-[10px] text-center transition-all duration-400 shadow-[0_4px_10px_rgba(0,0,0,0.05)] hover:transform hover:-translate-y-[5px] hover:shadow-[0_10px_20px_rgba(0,0,0,0.08)]" data-id="element-71">
            <img src="https://app.heylloyd.io/public/files/openrouter-generated-image-1770583571629.png" alt="Bitácora" className="w-full rounded-[4px] mb-[10px]" data-id="element-72" />
            <h3 className="text-[14px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-73">
              📓 Plantilla de Bitácora
            </h3>
            <div className="font-bold" data-id="element-74">
              <span className="text-[#EF4444] line-through" data-id="element-75">$7.99</span>
              <span className="text-[#10B981] block" data-id="element-76">HOY GRATIS</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}